import { render, staticRenderFns } from "./frmkedvezmenyezettek.vue?vue&type=template&id=6190cd9f&"
import script from "./frmkedvezmenyezettek.vue?vue&type=script&lang=js&"
export * from "./frmkedvezmenyezettek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports